export const DOCUMENTS_COUNT_PER_PAGE = 30
